import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "min-h-[100vh] bg-gray-950 flex flex-col md:flex-row md:justify-center"
};
const _hoisted_2 = {
  class: "flex-1 md:max-w-[35rem] pt-6"
};
const _hoisted_3 = {
  class: "text-white font-mono text-4xl font-bold ml-4 mt-4 mr-4 flex flex-col"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Token Manage", -1);
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "w-11/12 h-[0.1rem] bg-white mt-3 mb-3"
}, null, -1);
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "font-normal text-xl mb-4"
}, "Manage token which you created in Minthe ", -1);
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "flex-1 md:max-w-[30rem] text-white font-mono flex flex-col text-xl p-6 space-y-3"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "text-3xl font-bold mt-4"
}, "Create Solana Token"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createTextVNode("Effortlessly create your Solana SPL Token with our 7+1 step process – "), /*#__PURE__*/_createElementVNode("span", {
  class: "font-bold"
}, "no coding required"), /*#__PURE__*/_createTextVNode(".")]), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createTextVNode("Customize your Solana Token exactly the way you envision it. Less than "), /*#__PURE__*/_createElementVNode("span", {
  class: "underline"
}, "5 minutes"), /*#__PURE__*/_createTextVNode(", at an affordable cost.")]), /*#__PURE__*/_createElementVNode("br")], -1);
export function render(_ctx, _cache) {
  const _component_FlodableContainer = _resolveComponent("FlodableContainer");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _hoisted_5, _hoisted_6, _createVNode(_component_FlodableContainer, {
    title: "Update Metadata",
    description: "Update your token's metadata"
  })])]), _hoisted_7]);
}